import React from 'react';
import { HalfLayout } from './HalfLayout';
import ResponseTypo from './ResponseTypo';
import { StoryPlayer } from './StoryPlayer';
import '../../../styles/story/story.css';
import { SITE_CONFIG_KEY } from '../../../constants/types/site-config-type';
import { useSiteConfig } from '../../../hooks/useSiteConfig';

// API 조회 실패 시 사용할 기본값
const METHOD_VIDEO_FALLBACK = 'https://youtu.be/3ZMRsurB9jA';
const METHOD_TEXT_FALLBACK =
  '최고의 영어교재인 영어성경과\n정철 선생의 50년 영어교육 노하우가 만났습니다.\n누구도 따라할 수 없는 발명특허 ‘삽화기억술’';

const SITE_CONFIG_KEYS = [
  SITE_CONFIG_KEY.JEBS_STORY_METHOD_TEXT,
  SITE_CONFIG_KEY.JEBS_STORY_METHOD_VIDEO,
];

/** 젭스 스토리 - 삽화기억술 영역 */
export const StoryMethod = () => {
  const { configs, loading } = useSiteConfig(SITE_CONFIG_KEYS);
  const videoUrl =
    configs[SITE_CONFIG_KEY.JEBS_STORY_METHOD_VIDEO] || METHOD_VIDEO_FALLBACK;
  const text =
    configs[SITE_CONFIG_KEY.JEBS_STORY_METHOD_TEXT] || METHOD_TEXT_FALLBACK;

  return (
    <section className="bg-gradient-to-r from-spotLilac/[0.1] to-white p-5 lg:pb-14 lg:pt-20">
      <div className="lg:m-auto lg:max-w-[1024px]">
        <HalfLayout
          left={
            <div className="flex flex-col items-start text-left">
              <img src="./svg/story/icon-award.svg" alt="icon award" />
              <ResponseTypo variant_sm="h5" variant_lg="h4" className="mt-3 whitespace-pre-line break-keep lg:text-xl xl:text-2xl">
                {text}
              </ResponseTypo>
            </div>
          }
          // 설정 조회 전에 폴백 URL로 StoryPlayer 컴포넌트를 띄우면 URL이 바뀌며 다시 로드되므로 조회 후 넘긴다
          right={<StoryPlayer url={loading ? undefined : videoUrl} />}
        />
      </div>
    </section>
  );
};
